import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['body', 'link']

  track_change(event) {
    let currentForm = $(this.bodyTarget).closest('form')

    let hasErrors = (currentForm.find('.is-invalid').length > 0)
    
    if ((!hasErrors && currentForm.data('serialized').length < 150) || (hasErrors && currentForm.data('serialized').length < 250)) {
      return
    }

    if (!hasErrors) {
      hasErrors = (currentForm.find('.alert-danger').length > 0)
    }
    
    if ((currentForm.data('serialized') && currentForm.data('serialized') != currentForm.serialize()) || hasErrors ) {
      if (!confirm(this.bodyTarget.dataset.dialog_text)) {
        event.preventDefault()
        event.stopImmediatePropagation()
      }
    }
  }

}
